import { createI18nText } from '@hilma/netina2all';

const errText = createI18nText({
        he: {
                generalShort: 'אירעה שגיאה',
                generalSystem: 'הייתה תקלה במערכת',
                googleMapsStation: {
                        israelLoc: "הכתובת צריכה להיות בישראל",
                        locationNotFound: "הכתובת לא נמצאה",
                        userExists4station: 'כבר קיימת תחנת חלוקה עבור משתמש זה',
                },
                name: 'השם המלא אינו תקין',
                phone: 'מספר הטלפון אינו תקין',
                email: 'המייל אינו תקין',
                phoneWoOther: 'אנא הכנס מספר טלפון ללא רווחים או תווים אחרים',
                associationExists: 'כבר קיימת עמותה למשתמש זה',
                associationNameExists: 'שם העמותה תפוס',
                selectAKit: 'יש לבחור לפחות מוצר אחד',
                selectAStation: 'יש לבחור תחנה',
                nextSelectAStation: 'יש ללחוץ הבא ולבחור תחנה',
                selectValue: 'יש לבחור סכום',
                numbersOnly: 'יש להזין ספרות בלבד',
                numberTooBig: 'יש להזין מספר מתחת ל 2147483647',
                enterValue: 'יש להזין סכום',
                plsLogin: 'מספר טלפון זה כבר קיים במערכת, נא להתחבר',
                phoneExists: 'מספר טלפון זה כבר קיים במערכת',
                invalidInfo: 'אחד או יותר מהפרטים שהוזנו לא תקינים',
                succSaved: 'הפרטים נשמרו בהצלחה',
                notAllowed: 'פעולה זו אינה מורשה במצב הנוכחי',
                tooHeavy: 'הקבצים שנבחרו גדולים מדי',
                hebrew: 'נא לכתוב בעברית בלבד',
                twoDrivers: 'יש להוסיף ולשמור לפחות שני נהגים',
                driversNotSaved: 'ישנם נהגים שהוספו אך לא נשמרו',
                sucksaved: 'הפרטים נשמרו בהצלחה',
                suckupdated: 'הפרטים עודכנו בהצלחה',
                suckCopied: 'הקישור הועתק בהצלחה',
                purchaseCancelSuccess: "ההזמנה בוטלה בהצלחה",
                tryAgainLater: 'שגיאה. נסה שנית מאוחר יותר',
                purchaseCancelError: 'שגיאה במחיקת הזמנה',
                getDataError: 'שגיאה בהבאת מידע',
                website: 'חייב להתחיל ב //:https או //:http',
                intMax: 'צריך מספר סביר מ20 ומעלה',
                specifyLocation: 'אנא דייק את כתובתך.  נסה להשתמש במילים כמו "רחוב"',
                notEnoughSpaceStation: 'בתחנה שנבחרה אין מספיק מקום, אנא בחר תחנה אחרת',
                canPurchase: 'ניתן לרכוש כרגע',
                unavailableKit: 'אחד או יותר מהמוצרים שנבחרו אינו זמין, רעננו ונסו שנית',
                noLink: 'הקישור לא נמצא',
                campaignConflict: 'אנא נסו להשתמש במקור, מדיום ו/או תוכן שונים'
        },
        en: {
                generalShort: 'An error occurred',
                generalSystem: 'An error occurred',
                googleMapsStation: {
                        israelLoc: 'The address must be in Israel',
                        locationNotFound: 'The address was not found',
                        userExists4station: 'A distribution station already exists under this user',
                },
                name: 'The name is not valid',
                phone: 'The phone number is not valid',
                email: 'The email is not valid',
                phoneWoOther: 'Please enter a mobile number without any spaces or dashes',
                associationExists: 'An association already exists under this user',
                associationNameExists: 'The association name already exists',
                selectAKit: 'Please select at least one product',
                selectAStation: 'Please select a station',
                nextSelectAStation: 'Please press next and select a station',
                selectValue: 'Please select a sum',
                numbersOnly: 'Please enter only digets',
                numberTooBig: 'Please enter a number smaller than 2147483647',
                enterValue: 'Please enter a value',
                plsLogin: 'The phone number already exists in the system, please log in',
                phoneExists: 'The phone number already exists in the system',
                invalidInfo: 'One or more of the details entered are invalid',
                succSaved: 'The details were saved successfully',
                notAllowed: 'this action is not allowed in the current status',
                tooHeavy: 'The files selected are too heavy',
                hebrew: 'Please use Hebrew text only',
                twoDrivers: 'Please add at least two drivers',
                driversNotSaved: 'There are drivers that were added but were not saved',
                sucksaved: 'The details were saved successfully',
                suckupdated: 'The details were updated successfully',
                suckCopied: 'The link has been copied successfully',
                purchaseCancelSuccess: 'The order was successfully canceled',
                tryAgainLater: 'Error. Try again later',
                purchaseCancelError: 'Error in purchase cancellation',
                getDataError: 'error accessing data',
                website: 'must begin with https:// or http://',
                intMax: 'must be a rational number hiegher than 20',
                specifyLocation: 'Please specify your address. Try using words like "street"',
                notEnoughSpaceStation: "There isn't enough space in the selected station, please choose a diffrent one",
                canPurchase: 'Purchases can be made now',
                unavailableKit: "One or more of the selected products isn't available, please refresh",
                noLink: 'No link found',
                campaignConflict: 'Please try entering a different source, medium and/ or content'
        }
});

export default errText;